// extracted by mini-css-extract-plugin
export var container = "_5a-0";
export var infoButton = "_5a-1";
export var label = "_5a-3";
export var labelExpanded = "_5a-4";
export var price = "_5a-5";
export var priceExpanded = "_5a-6";
export var title = "_5a-2";